import React, { useState, useEffect, useRef, useMemo, RefObject } from 'react';

export const useIntersectionObserver = <T extends HTMLElement>(
  options: IntersectionObserverInit
): [RefObject<T>, boolean] => {
  const [isIntersecting, setIsIntersecting] = useState<boolean>(false);
  const elementRef = useRef<T>(null);

  const memoizedOptions = useMemo(() => options, [options.root, options.rootMargin, options.threshold]);

  useEffect(() => {
    const element = elementRef.current;
    if (!element) return;

    const observer = new IntersectionObserver(
      ([entry]) => setIsIntersecting(entry.isIntersecting),
      memoizedOptions
    );

    observer.observe(element);

    return () => observer.unobserve(element);
  }, [memoizedOptions]);

  return [elementRef, isIntersecting];
};
